import { render, staticRenderFns } from "./addUserStratorsList.vue?vue&type=template&id=5bc583a2&scoped=true&"
import script from "./addUserStratorsList.vue?vue&type=script&lang=js&"
export * from "./addUserStratorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc583a2",
  null
  
)

export default component.exports